import { useSpendSettingsIntl } from '@oc/pages/settings/SpendSettings/translations/useSpendSettingsIntl';
import { useMemo } from 'react';
import { StatusModel } from 'src/graphql/types';

export function useStatusOptions() {
  const intl = useSpendSettingsIntl();
  return useMemo(
    () => [
      { label: intl.statusEnabled, value: StatusModel.Active },
      { label: intl.statusDisabled, value: StatusModel.Inactive }
    ],
    [intl.statusDisabled, intl.statusEnabled]
  );
}
